import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const DAILY_RECAP = 'f9d890d0-416b-439a-8b32-b86b6b8c3a01';
export const ACTIVITY_HISTORY = '80b2c50d-784a-4559-8301-2d3993173ee6';
export const PROPERTY_SEARCH = 'dc930b68-4c78-4d89-b5e4-618deb501493';
export const DAILY_SUMMARY = '57a9ae80-dd54-424d-b243-83e6e495f28e';
export const HOME_VALUATION = '5d7a16ca-7d7a-432f-bee7-671cccc2e943';
export const MARKET_UPDATE = 'f2e7bb2b-eb96-4e3a-a6d4-7550f0ac8f20';
export const PRODUCT_TIPS_AND_TRICKS = '4568979b-57b9-4198-afd1-9ad2f20fbd1b';

export const ALL = {
    DAILY_RECAP,
    ACTIVITY_HISTORY,
    PROPERTY_SEARCH,
    DAILY_SUMMARY,
    HOME_VALUATION,
    MARKET_UPDATE,
    PRODUCT_TIPS_AND_TRICKS,
};

class LuNotificationTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-notification-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/notifications/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {

        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default LuNotificationTypeAppResource;
